
<div  *ngIf="valor==1">
    <p-progressBar [style]="{'height': '8px'}" mode="indeterminate" ></p-progressBar> 
</div>
